import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { AppServiceService } from './app-service.service';

@Injectable({
  providedIn: 'root'
})
export class AppMessagesService {

links:any;
errorMessages:any;
resetPassword:string;
updatePhone:string;
errorCode = "";
  constructor(private appConfigService:AppConfigService ,private appService:AppServiceService) { 
    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error)=>{
        //TODO
      })
  }

setErrorMessages(){
  if(this.appService.isMoeLogin){  
    this.resetPassword = this.links.resetPasswordMoe;
  }
  else{
  this.resetPassword = this.links.resetPassword;
  }
  this.updatePhone = this.links.updateDetails;
    this.errorMessages = new Map([
      ['WRONG_USERNAME_OR_PASSWORD',  "אחד או יותר מפרטי ההזדהות שגויים"],
      ['CAPTCHA_MISSING',  "בדיקת אימות 'אני לא רובוט' נכשלה"],
      ['WRONG_CAPTCHA',  "בדיקת אימות 'אני לא רובוט' נכשלה"],
      ['INVALID_INPUT'  , "שגיאה כללית"],
      ['WRONG_TOKEN' , "קוד האימות שהוזן שגוי, יש לנסות שוב"],
      ['SYSTEM_ERROR' , "שגיאה כללית במערכת"],
      ['PASSWORD_EXPIRED' , `פג תוקף סיסמתך <br> לקביעת סיסמה חדשה נא ללחוץ <a target='_blank' rel="noopener noreferrer" href=${this.resetPassword} class="underline">כאן</a>`],
      ['USER_NOT_FOUND'  , "אחד או יותר מפרטי ההזדהות שגויים"],
      ['GENERALE_ERROR' , "שגיאת מערכת"],
      ['TOKEN_TOKEN_EXPIRED' , "תוקף הסיסמה פג"],
      ['LOGIN_DISABLED', "חשבונך חסום!"],
      ['MISSING_OTP_TARGET' , `מספר הטלפון הנייד שלך אינו מוגדר במערכות המשרד <a target='_blank' rel="noopener noreferrer" href=${this.updatePhone} class="underline">לעדכון טלפון</a>`],
      ['CANNOT_SEND_SMS' , "שליחת ה - SMS נכשלה, אנא נסה שנית בעוד מספר דקות"],
      ['OTP_TOO_MANY_SENT' ,  `הוכנסו פרטים לא נכונים יותר מידי פעמים.<br>כדי לשמור על המידע שלך החשבון ננעל, וישוחרר בצורה אוטומטית בעוד זמן מה.`],
      ['INTRUDER_DETECTED' ,  `הוכנסו פרטים לא נכונים יותר מידי פעמים.<br>כדי לשמור על המידע שלך החשבון ננעל, וישוחרר בצורה אוטומטית בעוד זמן מה.<br>לקביעת סיסמה נא ללחוץ <a target='_blank' rel="noopener noreferrer" href=${this.resetPassword} class="underline">כאן</a>`],
      ['TOKEN_NOT_FOUND' , "קוד האימות שהוזן שגוי או פג תוקף. בדקות הקרובות יישלח אליך קוד אימות חדש"],
  ]);
 
  
  

}


  returnErrorMessage(error) { 
     if(this.errorMessages.has(error))
     return this.errorMessages.get(error);
     return(this.errorMessages.get('GENERALE_ERROR'))
  }


}
